<template>
	<div>
		<router-view></router-view>
	</div>
</template>

<script>
  import VueRouter from 'vue-router'
  import routes from './student/routes'
  import Http from "../classes/http";
  import { mapActions } from 'vuex'

  const router = new VueRouter({
    routes
  });
  export default {
    router,
    name: "student",
    provide(){
      return {
        http: new Http(this),
        site_settings: this.site_settings
      }
    },
    props: {
      obuser: '',
      site_settings: ''
    },
    watch: {
      $route(to, from) {
        // обрабатываем изменение параметров маршрута...
        this.checkOutsideUserSubscription();
      }
    },
    methods: {
      ...mapActions({
        getTrainers: 'train/getTrainers',
        getClasses: 'student/getStudentsClasses',
        getHomework: 'student/getHomework'
      }),
      changeUser() {
        if (this.obuser) {
          this.$store.commit('setUser', this.obuser);
        }
      },
      checkOutsideUserSubscription(){
        if (this.obuser.is_outside) {
          //console.log('Это чужие!!! А ну ка покажи абонемент, фашистская морда!');
          if (this.obuser.access) {
            //console.log('Прахады, маладэц');
          } else {
            //console.log('Стой! Идешь в камеру!');
            if (this.$route.path !== '/access-denied') this.$router.push('/access-denied');
          }
        }
        if (this.obuser.property && this.obuser.property.is_first_enter == 1) {
          console.log('Перенос');
          if (this.$route.path !== '/first-anketa') this.$router.push('/first-anketa');
        } else {
          if (this.$route.path === '/first-anketa') this.$router.push('/');
        }
      }
    },
    created() {
      this.changeUser();
    },
    mounted() {
      this.checkOutsideUserSubscription();      
      this.getTrainers()
      this.getClasses(this.obuser.id)
      this.getHomework(this.obuser.id)
    }
  }
</script>